import { getData } from '../utils/data.js';
export const ClientInquiryKind = {
    DeviceTroubles: 'deviceTroubles',
    DefrostDevice: 'defrostDevice',
    Others: 'others',
};
export const textClientInquiryKind = (v) => {
    switch (v) {
        case ClientInquiryKind.DeviceTroubles:
            return 'デバイスのトラブル等';
        case ClientInquiryKind.DefrostDevice:
            return '凍結中デバイスの修理';
        case ClientInquiryKind.Others:
            return 'その他';
    }
};
export const clientInquiryConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
export const ClientInquiryReplyConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
//# sourceMappingURL=clientInquiry.js.map